import { ReactNode } from "react";

import { ThemeProvider as EmoThemeProvider } from "@emotion/react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";

import theme from "./theme";

interface Props {
  children: ReactNode;
}

export default ({ children }: Props): JSX.Element => (
  <MuiThemeProvider theme={theme}>
    <EmoThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </EmoThemeProvider>
  </MuiThemeProvider>
);
